import { useAuthAxios } from '@/backend/utils'

const baseURL = process.env.NODE_ENV === 'development'
  ? '/api/v2/'
  : `${process.env.VUE_APP_BASE_URL}/api/v2/`

const http = useAuthAxios({ baseURL })

export function pricingLookup(payload) {
  const body = {
    departure_city: payload.departure_city,
    destination_city: payload.destination_city,
    departure_region: payload.departure_region ?? '',
    destination_region: payload.destination_region ?? '',
    transport_type: payload.transport_type ?? null,
  }
  return http.post('ati/pricing/lookup', body).then((r) => r.data)
}

export function getPricesHistory({ ati_route_id, days = 30, transport_type = null }) {
  const params = { ati_route_id, days }
  if (transport_type) params.transport_type = transport_type
  return http.get('ati/carriers/prices/history', { params }).then((r) => r.data)
}

export function refreshCarrierPrice({ ati_route_id, dry_run = false }) {
  return http.post('ati/carriers/prices/refresh', { ati_route_id, dry_run }).then((r) => r.data)
}

export function getRoutesWithStatus({ search = null, page = 1, per_page = 20 }) {
  const params = { page, per_page }
  if (search) params.search = search
  return http.get('ati/routes/with-status', { params }).then((r) => r.data)
}

export function getRateLimitPriorityList() {
  return http.get('ati/rate-limit/priority-list').then((r) => r.data)
}

export function getRateLimitUsageSummary() {
  return http.get('ati/rate-limit/usage-summary').then((r) => r.data)
}
